export default __webpack_public_path__ + "static/media/AuditLog_icon.f62a1b7b.svg";